export default __webpack_public_path__ + "static/media/mussila_mascot_love.2c437d0a.svg";